const ActionType = require("action-types/dialog");
const GTMCustom = require("../utils/gtm-custom");

exports.openDownloadDialog = croquisId => {
    return {
        type: ActionType.DIALOG_DOWNLOAD_OPEN,
        payload: { croquisId }
    };
};

exports.closeDownloadDialog = () => {
    return {
        type: ActionType.DIALOG_DOWNLOAD_CLOSE
    };
};

exports.openTransactionDialog = () => {
    return (dispatch, getState) => {
        const { auth } = getState();

        if (!auth.isAuthenticated) {
            return;
        }

        dispatch({
            type: ActionType.DIALOG_TRANSACTION_OPEN
        });

        GTMCustom.event("openPurchaseModal", auth.credentials.user.id);
    };
};

exports.closeTransactionDialog = () => {
    return {
        type: ActionType.DIALOG_TRANSACTION_CLOSE
    };
};

exports.openWhatsIncludedDialog = () => {
    return (dispatch, getState) => {
        dispatch({
            type: ActionType.DIALOG_INCLUDED_OPEN
        });

        const { auth } = getState();

        if (auth.isAuthenticated) {
            GTMCustom.event("openWhatsIncludedModal", auth.credentials.user.id);
        }
    };
};

exports.closeWhatsIncludedDialog = () => {
    return {
        type: ActionType.DIALOG_INCLUDED_CLOSE
    };
};



// WEBPACK FOOTER //
// ./src/actions/dialog.js